import { getUserToken } from './getUserToken';

type Listener = (token: string | undefined) => void;

const listeners = new Set<Listener>();

/**
 * Updates the user JWT everywhere it is mirrored and notifies subscribers.
 *
 * This is the only sanctioned write path: assigning `window.LumappsContext.token` or
 * `window.USER_ACCESS_TOKEN` directly leaves subscribers stuck on a dead token.
 */
export function setUserToken(token: string | undefined) {
    /**
     * `BaseApi.request` triggers a refresh on every request once inside the expiration
     * threshold, so concurrent refreshes commonly resolve to the same token. Bailing out early
     * avoids re-rendering every subscriber for a no-op.
     */
    if (getUserToken() === token) {
        return;
    }

    if (window.LumappsContext) {
        window.LumappsContext.token = token ?? '';
    }
    window.USER_ACCESS_TOKEN = token;

    for (const listener of listeners) {
        listener(token);
    }
}

/**
 * Subscribes to user JWT changes.
 *
 * @returns the unsubscribe function
 */
export function subscribeToUserToken(listener: Listener) {
    listeners.add(listener);

    return () => {
        listeners.delete(listener);
    };
}
